window.UpngB2b = window.UpngB2b || {};

function captureB2bClickIds() {
  const navigation = window.performance?.getEntriesByType('navigation')?.[0];
  const initialUrl = navigation?.name || window.location.href;
  let params;
  try {
    params = new URL(initialUrl, window.location.origin).searchParams;
  } catch (_error) {
    params = new URLSearchParams(window.location.search);
  }
  ['gclid', 'fbclid'].forEach((id) => {
    const value = params.get(id);
    if (value) window.sessionStorage.setItem(`upng_${id}`, value);
  });
}

captureB2bClickIds();

window.UpngB2b.initRegisterForm = function initRegisterForm({
  root,
  form,
  i18n,
  apiBase,
  locale,
  shopDomain,
  customerId,
  accountLoginUrl,
  isB2bCustomer,
  onSuccess,
  onAlreadyB2b,
}) {
  if (!root || !form) return;

  const requiresPassword = !customerId;
  const errorBox = root.querySelector('[data-b2b-error]');
  const successBox = root.querySelector('[data-b2b-success]');
  const confirmation = root.querySelector('[data-b2b-confirmation]');
  const registrationNotice = root.querySelector('[data-b2b-registration-notice]');
  const loginNotice = root.querySelector('[data-b2b-login-notice]');
  ['gclid', 'fbclid'].forEach((id) => {
    const input = root.querySelector(`[data-b2b-click-id="${id}"]`);
    if (input) input.value = window.sessionStorage.getItem(`upng_${id}`) || '';
  });
  const submitButton = form.querySelector('.b2b-register-submit, button[type="submit"]');
  const submitTextEl = submitButton ? submitButton.querySelector('[data-b2b-submit-text]') : null;
  const submitText = submitTextEl ? submitTextEl.textContent.trim() : (submitButton ? submitButton.textContent.trim() : '');

  if (confirmation && registrationNotice && registrationNotice.parentElement !== form) {
    const firstFieldGroup = form.querySelector('.grid, .b2b-address-grid');
    form.insertBefore(registrationNotice, firstFieldGroup || form.firstChild);
  }

  form.addEventListener('submit', handleB2bSubmit, true);
  handleHashRegistration();
  handlePendingLogin();

  function getB2bErrorMessage(code, fallback) {
    const messages = {
      B2B_EMAIL_UNAVAILABLE: i18n.emailUnavailable,
      B2B_PHONE_UNAVAILABLE: i18n.phoneUnavailable,
      B2B_COMPANY_NAME_UNAVAILABLE: i18n.companyUnavailable,
      B2B_REGISTRATION_CONFLICT: i18n.registrationConflict,
      B2B_REGISTRATION_INVALID: i18n.registrationInvalid,
    };

    return messages[code] || fallback || i18n.genericError;
  }

  function getField(selector) {
    return form.querySelector(selector);
  }

  function getValue(selector) {
    const field = getField(selector);
    return field ? field.value.trim() : '';
  }

  function getFieldForConflict(field) {
    switch (normalizeConflictField(field)) {
      case 'email': return getField('#b2b-register-email');
      case 'phone': return getField('#b2b-register-phone');
      case 'company': return getField('#b2b-register-company');
      case 'nif': return getField('#b2b-register-nif');
      case 'form': return form;
      default: return null;
    }
  }

  function normalizeConflictField(field) {
    const normalized = String(field || '').toLowerCase();
    if (normalized.includes('email')) return 'email';
    if (normalized.includes('phone') || normalized.includes('tel')) return 'phone';
    if (normalized.includes('company') || normalized.includes('empresa')) return 'company';
    if (normalized.includes('nif') || normalized.includes('dni')) return 'nif';
    return normalized;
  }

  function setLoading(isLoading, label) {
    if (!submitButton) return;
    submitButton.classList.toggle('is-loading', isLoading);
    submitButton.toggleAttribute('disabled', isLoading);
    if (submitTextEl) {
      submitTextEl.textContent = isLoading ? (label || i18n.sending) : submitText;
    }
  }

  function showMessage(type, message) {
    const target = type === 'success' ? successBox : errorBox;
    const other = type === 'success' ? errorBox : successBox;
    if (other) other.hidden = true;
    if (!target) return;
    target.textContent = message;
    target.hidden = false;
  }

  function clearMessages() {
    if (errorBox) errorBox.hidden = true;
    if (successBox) successBox.hidden = true;
  }

  function markInvalid(input) {
    input.classList.add('b2b-field-error');
    input.setAttribute('aria-invalid', 'true');
    const customSelect = input.closest('.b2b-custom-select');
    if (customSelect) customSelect.classList.add('b2b-field-error');
  }

  function clearInvalid(input) {
    input.classList.remove('b2b-field-error');
    input.removeAttribute('aria-invalid');
    const customSelect = input.closest('.b2b-custom-select');
    if (customSelect) customSelect.classList.remove('b2b-field-error');
  }

  function showServerConflicts(conflicts) {
    clearMessages();
    if (confirmation) {
      if (!errorBox) return;
      const conflictFields = new Set(conflicts.map((conflict) => normalizeConflictField(conflict.field || conflict.code)).filter(Boolean));
      const hasEmailConflict = conflictFields.has('email');
      const isSingleKnownConflict = conflictFields.size === 1;
      const message = document.createElement('p');
      message.className = 'mb-0';

      conflicts.forEach((conflict) => {
        const input = getFieldForConflict(conflict.field || conflict.code);
        if (input && input !== form) markInvalid(input);
      });

      if (hasEmailConflict) {
        const payload = buildPendingPayload();
        window.sessionStorage.setItem('upng_b2b_pending_login', JSON.stringify({ email: payload.email }));
        message.textContent = i18n.registrationConflict;
        errorBox.innerHTML = '';
        errorBox.classList.add('text-center');
        errorBox.setAttribute('tabindex', '-1');
        errorBox.append(message, buildLoginLink(payload));
      } else {
        if (isSingleKnownConflict && conflictFields.has('phone')) message.textContent = i18n.phoneUnavailable;
        else if (isSingleKnownConflict && conflictFields.has('company')) message.textContent = i18n.companyUnavailable;
        else if (isSingleKnownConflict && conflictFields.has('nif')) message.textContent = i18n.nifUnavailable;
        else message.textContent = i18n.genericConflict;
        errorBox.innerHTML = '';
        errorBox.classList.add('text-center');
        errorBox.setAttribute('tabindex', '-1');
        errorBox.append(message);
      }

      if (hasEmailConflict) {
        const support = document.createElement('p');
        support.className = 'mt-4 mb-0';
        support.textContent = i18n.supportMessage;
        errorBox.append(support);
      }
      errorBox.hidden = false;
      window.requestAnimationFrame(() => {
        errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        errorBox.focus({ preventScroll: true });
      });
      return;
    }

    const messages = [];
    let firstInvalid = null;

    conflicts.forEach((conflict) => {
      const input = getFieldForConflict(conflict.field || conflict.code);
      if (input && input !== form) {
        markInvalid(input);
        if (!firstInvalid) firstInvalid = input;
      }
      messages.push(conflict.message);
    });

    showMessage('error', `${i18n.errorTitle} ${messages.join(' ')}`);
    if (firstInvalid) {
      firstInvalid.focus({ preventScroll: false });
    }
  }

  function buildLoginLink(payload) {
    const loginLink = document.createElement('a');
    loginLink.className = 'btn btn--primary mt-4';
    loginLink.style.textDecoration = 'none';
    loginLink.href = '#login';
    loginLink.textContent = i18n.loginCta;
    loginLink.addEventListener('click', (event) => {
      event.preventDefault();
      openLoginTab(payload);
    });
    return loginLink;
  }

  function openLoginTab(payload) {
    const loginTab = root.querySelector('#tab-0');
    const loginEmail = root.querySelector('#customer-email');
    const loginForm = root.querySelector('#login form');
    if (!loginTab) return;

    loginTab.click();
    if (loginForm) loginForm.noValidate = true;
    if (loginEmail && payload.email) {
      loginEmail.value = payload.email;
      loginEmail.focus();
    }
    if (loginNotice) {
      loginNotice.textContent = i18n.registrationConflict;
      loginNotice.hidden = false;
    }
    root.querySelector('.modal__content')?.scrollTo({ top: 0, behavior: 'smooth' });

    const returnUrl = new URL(window.location.href);
    returnUrl.searchParams.set('b2b_continue', '1');
    let returnInput = loginForm?.querySelector('input[name="return_to"]');
    if (!returnInput && loginForm) {
      returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      loginForm.appendChild(returnInput);
    }
    if (returnInput) returnInput.value = returnUrl.pathname + returnUrl.search;
  }

  async function validateRegistrationWithServer(payload) {
    const response = await fetch(`${apiBase}/api/b2b/validate-registration`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const result = await response.json().catch(() => ({}));
    if (!response.ok || result.ok === false) {
      if (Array.isArray(result.conflicts) && result.conflicts.length > 0) {
        showServerConflicts(result.conflicts);
        return false;
      }

      const conflictFieldByCode = {
        B2B_EMAIL_UNAVAILABLE: 'email',
        B2B_PHONE_UNAVAILABLE: 'phone',
        B2B_COMPANY_NAME_UNAVAILABLE: 'company',
      };
      if (conflictFieldByCode[result.code]) {
        showServerConflicts([{ field: conflictFieldByCode[result.code], code: result.code }]);
        return false;
      }

      throw new Error(getB2bErrorMessage(result.code, result.message));
    }

    return true;
  }

  function validateB2bForm() {
    const requiredSelectors = [
      '#b2b-register-first-name',
      '#b2b-register-last-name',
      '#b2b-register-email',
      '#b2b-register-company',
      '#b2b-register-nif',
      '#b2b-register-street-type',
      '#b2b-register-address',
      '#b2b-register-zip',
      '#b2b-register-city',
      '#b2b-register-province',
      '#b2b-register-sector',
    ];

    if (requiresPassword) {
      requiredSelectors.push('#b2b-register-password', '#b2b-register-confirm-password');
    }
    let firstInvalid = null;
    let validationMessage = '';

    requiredSelectors.forEach((selector) => {
      const input = getField(selector);
      if (!input) return;
      clearInvalid(input);
      if (!input.value || !input.value.trim()) {
        markInvalid(input);
        if (!firstInvalid) firstInvalid = input;
      }
    });

    const email = getField('#b2b-register-email');
    if (email && email.value && !email.checkValidity()) {
      markInvalid(email);
      if (!firstInvalid) firstInvalid = email;
    }

    const nif = getField('#b2b-register-nif');
    if (nif && nif.value && !window.UpngB2b.validarNIF(nif.value)) {
      markInvalid(nif);
      if (!firstInvalid) firstInvalid = nif;
      validationMessage = i18n.nifInvalid;
    }

    if (requiresPassword) {
      const password = getField('#b2b-register-password');
      const confirmPassword = getField('#b2b-register-confirm-password');

      const MIN_PASSWORD_LENGTH = 6;

      if (password && password.value && password.value.length < MIN_PASSWORD_LENGTH) {
        markInvalid(password);
        if (confirmPassword) markInvalid(confirmPassword);
        if (!firstInvalid) firstInvalid = password;
        showMessage('error', i18n.passwordMinLength);
        return false;
      }

      if (password && confirmPassword && password.value !== confirmPassword.value) {
        markInvalid(password);
        markInvalid(confirmPassword);
        if (!firstInvalid) firstInvalid = confirmPassword;
        showMessage('error', i18n.passwordMismatch);
        return false;
      }
    }

    const terms = getField('#b2b-register-terms');
    if (terms) {
      clearInvalid(terms);
      if (!terms.checked) {
        markInvalid(terms);
        if (!firstInvalid) firstInvalid = terms;
      }
    }

    if (firstInvalid) {
      showMessage('error', validationMessage || i18n.reviewRequiredFields);
      firstInvalid.focus({ preventScroll: false });
      return false;
    }

    clearMessages();
    return true;
  }

  function buildPendingPayload() {
    return {
      shop: window.Shopify?.shop || shopDomain,
      customerId: customerId || '',
      firstName: getValue('#b2b-register-first-name'),
      lastName: getValue('#b2b-register-last-name'),
      email: getValue('#b2b-register-email'),
      password: getValue('#b2b-register-password'),
      phone: getValue('#b2b-register-phone'),
      gclid: getValue('[data-b2b-click-id="gclid"]'),
      fbclid: getValue('[data-b2b-click-id="fbclid"]'),
      company: getValue('#b2b-register-company'),
      nif: getValue('#b2b-register-nif').toUpperCase(),
      sector: getValue('#b2b-register-sector'),
      streetType: getValue('#b2b-register-street-type'),
      address1: getValue('#b2b-register-address'),
      zip: getValue('#b2b-register-zip'),
      city: getValue('#b2b-register-city'),
      province: getValue('#b2b-register-province'),
      countryCode: 'ES',
      locale,
    };
  }

  async function handleB2bSubmit(event) {
    if (form.dataset.b2bNativeSubmitting === 'true') return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    if (!validateB2bForm()) return;

    const payload = buildPendingPayload();
    if (!customerId) {
      const isValid = await validateRegistrationWithServer(payload).catch((error) => {
        showMessage('error', error.message || i18n.errorTitle);
        return false;
      });

      if (!isValid) {
        setLoading(false);
        return;
      }
    }

    if (customerId) {
      setLoading(true, i18n.completingButton);
      showMessage('success', i18n.completingRegistration);
      try {
        const response = await fetch(`${apiBase}/api/b2b/complete-registration`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...payload, customerId }),
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok || result.ok === false) {
          const fallbackMessage = result.message && result.message !== 'Server Error' ? result.message : undefined;
          throw new Error(getB2bErrorMessage(result.code, fallbackMessage));
        }
        showMessage('success', i18n.registrationSuccess);
        finishSuccess();
      } catch (error) {
        console.error('[B2B] No se pudo completar el registro B2B', error);
        showMessage('error', error.message || i18n.b2bDataFailed);
        setLoading(false);
      }
      return;
    }

    const returnToField = form.querySelector('input[name="return_to"]');
    if (returnToField) {
      const baseReturnTo = returnToField.value || window.location.pathname;
      returnToField.value = baseReturnTo + '#b2b=' + btoa(encodeURIComponent(JSON.stringify(payload)));
    }

    setLoading(true, i18n.sending);
    showMessage('success', i18n.creatingAccount);
    form.dataset.b2bNativeSubmitting = 'true';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitButton || undefined);
    } else {
      form.submit();
    }
  }

  async function handleHashRegistration() {
    const hash = window.location.hash;
    if (!hash || !hash.startsWith('#b2b=')) return;

    // Si Shopify ha devuelto un error (p. ej. contraseña demasiado corta) no se ha creado ninguna cuenta => no se hace el auto-login
    if (root.querySelector('.alert.bg-error-bg')) {
      cleanHash();
      return;
    }

    let payload;
    try {
      payload = JSON.parse(decodeURIComponent(atob(hash.slice(5))));
    } catch (_error) {
      cleanHash();
      return;
    }

    cleanHash();

    if (!customerId) {
      if (!payload.password || window.sessionStorage.getItem('upng_b2b_login_attempted') === 'true') {
        showMessage('error', i18n.loginFailed);
        return;
      }

      window.sessionStorage.setItem('upng_b2b_login_attempted', 'true');
      const loginForm = document.createElement('form');
      loginForm.method = 'post';
      loginForm.action = accountLoginUrl;
      loginForm.style.display = 'none';
      loginForm.innerHTML = `
        <input type="hidden" name="customer[email]" value="${payload.email.replace(/&/g, '&amp;').replace(/"/g, '&quot;')}">
        <input type="hidden" name="customer[password]" value="${payload.password.replace(/&/g, '&amp;').replace(/"/g, '&quot;')}">
        <input type="hidden" name="return_url" value="${window.location.pathname + window.location.search + '#b2b=' + btoa(encodeURIComponent(JSON.stringify(payload)))}">
      `;
      document.body.appendChild(loginForm);
      loginForm.submit();
      return;
    }

    const nativeSuccess = form.querySelector('.alert.bg-success-bg');
    if (nativeSuccess) nativeSuccess.hidden = true;

    setLoading(true, i18n.completingButton);

    try {
      const response = await fetch(`${apiBase}/api/b2b/complete-registration`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...payload, customerId: customerId || '' }),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.ok === false) {
        const fallbackMessage = result.message && result.message !== 'Server Error' ? result.message : undefined;
        throw new Error(getB2bErrorMessage(result.code, fallbackMessage));
      }
      finishSuccess();
    } catch (error) {
      console.error('[B2B] No se pudo completar el registro B2B', error);
      showMessage('error', error.message || i18n.b2bDataFailedAfterAccount);
      setLoading(false);
      if (form) form.dataset.b2bNativeSubmitting = '';
    }
  }

  function cleanHash() {
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
    }
  }

  function handlePendingLogin() {
    if (!customerId || !confirmation || new URLSearchParams(window.location.search).get('b2b_continue') !== '1') return;

    let pendingLogin;
    try {
      pendingLogin = JSON.parse(window.sessionStorage.getItem('upng_b2b_pending_login') || 'null');
    } catch (_error) {
      pendingLogin = null;
    }
    if (!pendingLogin) return;

    if (isB2bCustomer) {
      window.sessionStorage.removeItem('upng_b2b_pending_login');
      cleanContinueQuery();
      if (typeof onAlreadyB2b === 'function') onAlreadyB2b();
      return;
    }

    confirmation.hidden = false;
    form.hidden = true;
    if (registrationNotice) registrationNotice.hidden = true;

    confirmation.querySelector('[data-b2b-confirm]')?.addEventListener('click', () => {
      confirmation.hidden = true;
      form.hidden = false;
      if (registrationNotice) registrationNotice.hidden = false;
      cleanContinueQuery();
    }, { once: true });

    confirmation.querySelector('[data-b2b-cancel]')?.addEventListener('click', () => {
      window.sessionStorage.removeItem('upng_b2b_pending_login');
      confirmation.hidden = true;
      form.hidden = false;
      if (registrationNotice) registrationNotice.hidden = false;
      cleanContinueQuery();
    }, { once: true });
  }

  function cleanContinueQuery() {
    const url = new URL(window.location.href);
    url.searchParams.delete('b2b_continue');
    window.history.replaceState(null, document.title, url.pathname + url.search);
  }

function finishSuccess() {
  window.sessionStorage.removeItem('upng_b2b_pending_login');
  setLoading(false);

  // Notificar que el registro B2B se ha completado correctamente
  if (window.Shopify?.analytics?.publish) {
    window.Shopify.analytics.publish('upng_b2b:registration_success', {
      form_id: 'modal-b2b-register',
      lead_type: 'b2b'
    });
  }

  if (typeof onSuccess === 'function') onSuccess();
  }
};
